module.exports = __webpack_public_path__ + "static/ch-1-endcard-bg@2x-c190036ce94b5d5be2dd91000ee61512.jpg";